import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialOpenStoragePageState,
  OpenStorageItemData,
} from "../core/_model.openStorage";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedOpenStorage = {
  data: OpenStorageItemData | null;
  action: ActionsKey;
};

type OpenStorageDataType = {
  openStorageList: any;
  detail: OpenStorageItemData | null;
  actioned: ActionedOpenStorage | null;
  totalItems?: number;
  setDetail: (detail: OpenStorageItemData | null) => void;
  setOpenStorageList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedOpenStorage | null) => void;
};

export const useOpenStorageStore = create<OpenStorageDataType>(
  (set) => ({
    openStorageList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setOpenStorageList: (saleData) =>
      set((state) => ({
        openStorageList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useOpenStorageListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialOpenStoragePageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
